module.exports = __webpack_public_path__ + "img/icon_make.1c224910.jpeg";